import React from "react";
import { Modal, Form, Input, Button } from "antd";
import {
  createHealthInfo,
  updateHealthInfo,
} from "../../store/healthInfoSlice";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../../config";

const StudentHealthInfoForm = ({
  open,
  onCancel,
  onSave,
  initialValues,
  onSaveFail,
  mode,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("userInfo");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  const storedToken = localStorage.getItem("token");
  if (mode === "create") {
    initialValues = {
      referenceHospital: "Not Available", // Default value for referenceHospital
      hospitalNumber: "Not Available", // Default value for hospitalNumber
      doctorNumber: "09904", // Default value for doctorNumber
      doctorName: "Not Avialable", // Default value for doctorName
      healthDescription: "Not Applicable", // Default value for healthDescription
      vaccinationStatus: "Not Apllicable", // Default value for vaccinationStatus
      vaccinationExplanation: "Not Applicable", // Default value for vaccinationExplanation
    };
  }
  if (!userData || !storedToken) {
    throw new Error("No user data or token found");
  }

  const studentId = userData.studentIds?.[0];
  console.log("userData", userData);
    console.log("initialValues", initialValues);
    console.log("initialValues", initialValues.healthID);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      console.log("values", values);
      console.log("studentId", studentId);
      const healthId = initialValues.healthID;
      const action = mode === "create" ? createHealthInfo : updateHealthInfo;

      // Dispatch action with studentId and form data
      const resultAction = await dispatch(
        action({ studentId, healthId, healthData: values })
      );
    if (action.fulfilled.match(resultAction)) {
      onSave();
    } else if (action.rejected.match(resultAction)) {
      // Show the error message returned from the backend
      onSaveFail(action.error || "Failed to submit data");
    }
      // Call the onSave function to refresh data and close the modal
      
    } catch (error) {
      onSaveFail(error.message || "Failed to submit data");
    }
  };

  return (
    <Modal
      title={
        mode === "create" ? "Add Health Information" : "Edit Health Information"
      }
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} initialValues={initialValues} layout="vertical">
        <Form.Item
          name="referenceHospital"
          label="Reference Hospital Name"
          rules={[
            { required: true, message: "Please input the reference hospital!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="hospitalNumber"
          label="Hospital Phone Number"
          rules={[
            { required: true, message: "Please input the hospital number!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="doctorNumber"
          label="Doctor Number"
          rules={[
            { required: true, message: "Please input the doctor number!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="doctorName"
          label="Doctor Name"
          rules={[{ required: true, message: "Please input the doctor name!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="healthDescription"
          label="Health Description"
          rules={[
            { required: true, message: "Please input the health description!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="vaccinationStatus"
          label="Vaccination Status"
          rules={[
            { required: true, message: "Please input the vaccination status!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="vaccinationExplanation"
          label="Vaccination Explanation"
          rules={[
            {
              required: true,
              message: "Please input the vaccination explanation!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleOk}>
            {mode === "create" ? "Add" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StudentHealthInfoForm;
